import { CommissionType, ProductType } from "../../../../utils/Order/Order";

export const clientPrice = (side, markupType, markup, price, isDiscount) => {
  if (
    side != undefined &&
    markupType != undefined &&
    markup != undefined &&
    markup !== "" &&
    price != undefined &&
    price !== ""
  ) {
    const sideSign = (side == "Buy" && !isDiscount) || (side == "Sell" && isDiscount) ? 1 : -1;

    if (markupType == CommissionType.FaceValueCash) {
      return +price + sideSign * +markup;
    }

    return +price + sideSign * +price * (+markup / 100);
  }

  return null;
};

export const clientRate = (side, markupType, markup, rate) => {
  if (
    side != undefined &&
    markupType != undefined &&
    markup != undefined &&
    markup !== "" &&
    rate != undefined &&
    rate !== ""
  ) {
    const sideSign = side == "Buy" ? -1 : 1;

    if (markupType == CommissionType.FaceValueCash) {
      return +rate + sideSign * +markup;
    }

    return +rate + sideSign * +rate * (+markup / 100);
  }

  return null;
};

export const accountProps = ({ order, readonly, errors }) => {
  return {
    order,
    account: order.CurrentAccount,
    hasAttachment: order.CurrentAccount.HasFileUploadPending
      ? { uploadPending: true }
      : order.CurrentAccount.AttachmentFileType,
    readonly,
    errors,
  };
};

export const commissionSuffix = (commissionType, currencySymbol = "") => {
  if (commissionType == CommissionType.PrincipalPercentage) {
    return { suffix: "%" };
  }
  if (commissionType == CommissionType.FaceValueCash && currencySymbol !== "") {
    return { prefix: `${currencySymbol} ` };
  }

  return null;
};

export const customFetchAssetInfo = (dispatch, services, order) => {
  const assetInfoData = {
    tradeDate: order.OrderInitDate,
    valueDate: order.OrderFutureSettlmentDate,
    fixedValueDate: true,
    orderForm: order.AssetClassForm,
    assetId:
      order.AssetClassForm === ProductType.REPO && order.CurrentAccount.Collateral
        ? order.CurrentAccount.Collateral[0].AssetId
        : order.AssetId,
    assetTicker:
      order.AssetClassForm === ProductType.REPO && order.CurrentAccount.Collateral
        ? order.CurrentAccount.Collateral[0].AssetTicker
        : order.AssetTicker,
    tradeCurrencyId: order.OrderCurrencyId,
    settleCurrencyId: order.OrderSettlementCurrencyId,
  };

  return services.assetInfo(assetInfoData).then((response) => {
    const { assetorderdata } = response.response;

    dispatch({ type: "FETCH_ASSET_INFO", data: assetorderdata });

    return assetorderdata;
  });
};

export const customFetchAccountInfo = (dispatch, services, params, updateOrderValues) => {
  const fetchTasks = [services.accountInfo(params), services.commissionInfo(params)];

  return Promise.all(fetchTasks).then((taskResults) => {
    const { kvpItems } = taskResults[1].response;

    dispatch({ type: "FETCH_ACCOUNT_INFO", items: kvpItems, updateOrderValues });

    return taskResults[0];
  });
};
